<template>
  <PreviousOrders
    v-if="showPreviousOrdersPage || !order.products.length"
    :orders="previousOrders"
    @closePreviousOrders="closePreviousOrders"
  />
  <div v-else>
    <v-app-bar
      app
      fixed
      dense
      flat
      :class="{ 'background-dark': isDark, 'background-light': !isDark }"
    >
      <v-btn icon @click="closeOrder" style="mix-blend-mode:difference">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t("Your order") }}</v-toolbar-title>
      <v-spacer />
    </v-app-bar>

    <v-content
      :class="{
        'fill-height': true,
        'background-dark': isDark,
        'background-light': !isDark
      }"
    >
      <v-row class="d-flex flex-column fill-height" justify="space-between">
        <v-col>
          <OrderProduct
            v-for="(product, i) in order.products"
            :key="i"
            :orderProduct="product"
            @removeOrderProduct="_ => removeOrderProduct(i)"
          />
        </v-col>
        <hr class="mx-5" />
        <!-- <div class="text-right">{{ localizedPrice(totalPrice) }}</div> -->
        <v-col class="d-flex justify-end">
          <div
            class="primary--text body-1 font-weight-bold"
            @click="confirmOrder"
          >{{ $t("ORDER FOR {price}", { price: localizedPrice(totalPrice) }) }}</div>
          <!-- <v-btn text exact color="primary" @click="confirmOrder">
            Order for {{ localizedPrice(totalPrice) }}
          </v-btn>-->
        </v-col>
      </v-row>
    </v-content>

    <v-footer
      v-if="hasPreviousOrder"
      app
      :class="{
        'background-dark': isDark,
        'background-light': !isDark
      }"
    >
      <v-container fluid class="fill-height">
        <v-row class="d-flex flex-column" justify="end" align="center">
          <v-btn outlined color="primary" @click="showPreviousOrders">{{ $t("Show order") }}</v-btn>
        </v-row>
      </v-container>
    </v-footer>

    <v-bottom-sheet v-model="sheet" v-if="false">
      <template v-slot:activator="{ on }">
        <v-flex class="d-flex justify-center" style="color:grey">
          <v-btn
            fixed
            bottom
            color="primary"
            rounded
            x-large
            v-on="on"
          >Pay {{ localizedPrice(totalPrice) }}</v-btn>
        </v-flex>
      </template>
      <v-sheet class="text-center pb-12" min-height="450px">
        <h1 class="text--darken-3 grey--text py-10">Total {{ localizedPrice(totalPrice) }}</h1>
        <h1 class="text--darken-2 grey--text">Select payment method</h1>
        <h4>Call waiter to pay with:</h4>
        <v-btn class="my-8" bottom color>Cash</v-btn>
        <v-btn class="my-8" bottom color>Card</v-btn>

        <h4>or pay with:</h4>
        <gpaybutton class="my-8" :price="totalPrice" currencyCode="EUR" />

        <!-- <v-btn
          class="mt-8"
          flat
          fixed
          top
          right
          color=""
          @click="sheet = !sheet"
        >x</v-btn>-->
      </v-sheet>
    </v-bottom-sheet>
    <!-- <v-flex v-if="order.length==0" class="d-flex justify-center mb-6" style="color:grey">
       <v-btn  fixed bottom color="primary" rounded x-large>Pay {{localizedPrice(totalPrice)}}</v-btn>
      <gpaybutton  :price="totalPrice" currencyCode="EUR"/>
    </v-flex>-->
    <v-bottom-navigation v-if="order.length > 0" app grow class="align-center">
      <!-- <v-btn value="pastOrder" @click>
        <span>Past Orders</span>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>-->

      <!-- <v-btn v-if="order.length" value="Order" @click="confirmOrder" id>
        <span>Confirm Order</span>
        <v-icon>playlist_add_check</v-icon>
      </v-btn>-->

      <!-- <gpaybutton  :price="totalPrice" currencyCode="EUR"/> -->

      <h3 style="color:grey">Total {{ localizedPrice(totalPrice) }}</h3>
    </v-bottom-navigation>
  </div>
</template>
<script>
import gpaybutton from "@/components/GPay.vue";
import OrderProduct from "@/components/OrderProduct.vue";
import PreviousOrders from "@/components/PreviousOrders.vue";
// import { messaging } from "@/firebase/firestore.js";

export default {
  name: "Order",
  props: ["order", "previousOrders"],
  components: { gpaybutton, OrderProduct, PreviousOrders },

  data: function() {
    return {
      comment: "",
      sheet: false,
      showPreviousOrdersPage: false
    };
  },

  methods: {
    confirmOrder() {
      // if (this.$store.getters.isNotified) {
      //   this.notificationsPermisionRequest();
      // }
      this.$emit("confirmOrder");
    },

    closeOrder() {
      this.$emit("closeOrder");
    },

    showPreviousOrders() {
      this.showPreviousOrdersPage = true;
    },

    closePreviousOrders() {
      this.showPreviousOrdersPage = false;
      if (!this.order.products.length) {
        this.closeOrder();
      }
    },

    localizedPrice(price) {
      return (
        price.toLocaleString("es-ES", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + " €"
      );
    },

    removeOrderProduct(productIndex) {
      const shouldClose = this.order.products.length === 1;
      this.$emit("removeOrderProduct", productIndex);
      if (shouldClose) {
        this.closeOrder();
      }
    },
    getMessagingToken() {
      messaging
        .getToken()
        .then(async token => {
          if (token) {
            const currentMessageToken = window.localStorage.getItem(
              "messagingToken"
            );
            console.log("token will be updated", currentMessageToken != token);
            if (currentMessageToken != token) {
              await this.saveToken(token);
            }
          } else {
            console.log(
              "No Instance ID token available. Request permission to generate one."
            );
            this.notificationsPermisionRequest();
          }
        })
        .catch(function(err) {
          console.log("An error occurred while retrieving token. ", err);
        });
    },
    notificationsPermisionRequest() {
      messaging
        .requestPermission()
        .then(() => {
          this.getMessagingToken();
        })
        .catch(err => {
          console.log("Unable to get permission to notify.", err);
        });
    },
    listenTokenRefresh() {
      const currentMessageToken = window.localStorage.getItem("messagingToken");
      console.log("currentMessageToken", currentMessageToken);
      if (currentMessageToken) {
        messaging.onTokenRefresh(function() {
          messaging
            .getToken()
            .then(function(token) {
              this.saveToken(token);
            })
            .catch(function(err) {
              console.log("Unable to retrieve refreshed token ", err);
            });
        });
      }
    },
    saveToken(token) {
      this.$store.commit("set", {
        varName: "notifyToken",
        value: token
      });
    }
  },
  created() {
    // messaging.onMessage(payload => {
    //   console.log("Message received. ", payload);
    //   // ...
    // });
  },

  mounted() {
    const closeOrder = this.closeOrder;
    window.onpopstate = function() {
      closeOrder();
    };

    history.pushState({}, "");
    this.$vuetify.goTo(0, { duration: 0 });
  },

  computed: {
    totalPrice() {
      return this.order.totalPrice;
    },

    totalPriceUnconfirmed() {
      // TODO currently "on buffer" order let total = 0;
      // for (let product in dataManager.order) {
      //   total = total + parseFloat(dataManager.order[product].price);
      // }

      return this.order.totalPrice;
    },

    totalPriceConfirmed() {
      // let total = 0;
      // for (let order in dataManager.previousOrders) {
      //   for (let product in dataManager.previousOrders[order]) {
      //     total =
      //       total + parseFloat(dataManager.previousOrders[order][product].price);
      //   }
      // }
      // TODO previous unpaid from today and this establishment orders
      let totalPrice = 0;
      this.previousOrders.forEach(
        pastOrder => (totalPrice += pastOrder.totalPrice)
      );
      return totalPrice;
    },

    hasPreviousOrder() {
      return this.previousOrders.length;
    },

    isDark() {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
  },

  watch: {
    order() {
      this.showPreviousOrdersPage = !this.order.products.length;
    }
  }
};
</script>

<style scoped>
.background-dark {
  background-color: #1e1e1e !important;
}
.background-light {
  background-color: white !important;
}
</style>
